<template>
 <div>
    <Header title="重修选课" type="0" route="/student/retouchList" :casLogin="casLogin"></Header>
    <div class="center">
      <div class="center-list" v-for="(item,index) in dataList" :key="index">
        <div class="list-left">
          <div class="left-title">{{item.kcmc}}({{item.kch}})</div>
          <div class="left-line">
            <span style="color:blue">上课班级:</span>
            <span style="margin-left: 5px;">{{item.ktmc}}</span>
          </div>
          <div class="left-line">
            <span style="color:blue">上课老师:</span>
            <span style="margin-left: 5px;">{{item.skls}}</span>
          </div>
          <div class="left-line">
            <span style="color:blue">上课时间地点:</span>
            <span style="margin-left: 5px;">{{item.sksjdd}}</span>
          </div>
        </div>
        <div class="list-right">
          <van-button
            type="default"
            class="right-button"
            @click="doChooseCure(item)"
          >选择</van-button>
        </div>
       
      </div>
      <van-empty
        v-if="NOdata"
        class="custom-image"
        image="static/img/no_data.png"
        description="暂无数据"
      />
    </div>
  </div>
</template>
<script>
import { Api } from '@/utils/axios'
export default {
  data() {
    return {
      dataList:[],
      retouchId:this.$route.params.retouchId,
    }
  },
  created() {
   this.getList();
  },
  methods: {
    async getList() {
      const params = {
        retouchId:this.retouchId
      }
      const res = await Api.cxbmxk_getXkKc(params);
      if(res.code=='1'){
        this.dataList = res.data;
      }
    },
    async doChooseCure(item){
      const params = {
        retouchId:item.cj0721id,
        tzdId:item.jx0404id
      }
      const res = await Api.cxbmxk_saveXkRuslt(params);
      if(res.code=='1'){
        this.$toast.success("选课成功!");
        setTimeout(() => {
          this.$router.replace("/student/retouchList");
        }, 1500);
      }
    }
  }

}
</script>

<style lang="less" scoped>
.center {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 20px;
}
.search-top {
  width: calc(~'100% - 40px');
  display: flex;
  align-items: center;
  padding: 20px 20px 0px 20px;
  flex-wrap: wrap;
}
.top-line {
  padding: 5px 14px;
  margin-right: 20px;
  background: @attendance-background-color-7;
  color: @attendance-background-color-1;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
}
.search-result {
  width: calc(~'100% - 40px');
  padding: 0px 20px;
  color: @attendance-color-1;
  font-size: 18px;
  font-weight: 600;
  margin-top: 16px;
}
.center-list {
  width: calc(~'100% - 80px');
  background: @attendance-background-color-10;
  border-radius: 5px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 20px 20px 18px 20px;
}
.list-left {
  width: calc(~'100% - 70px');
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.left-title {
  width: 100%;
  font-size: 16px;
  color: @attendance-color-1;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 8px;
}
.left-line {
  width: 100%;
  font-size: 12px;
  color: @attendance-color-2;
  margin-bottom: 2px;
}
.list-right {
  width: 70px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.right-button {
  width: 70px;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  text-align: center;
  background-color: @attendance-background-color-1;
  border-radius: 3px;
}
.right-span {
  background: @attendance-background-color-10;
  color: @attendance-background-color-1;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
}
.custom-image /deep/.van-empty__image {
  width: 130px;
  height: 130px;
}
</style>


// WEBPACK FOOTER //
// src/components/student/retouchSignUp/retouchChooseCureList.vue